import { useEffect, useState, useCallback } from "react";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import { Link } from "react-router-dom";
import AdminHeader from "../header";
import AdminSidebar from "../sidebar";
import AdminServices from "../../../services/AdminServices";
import "../../assets/css/custom.css"; // Adjust the path if needed


const SchoolLists = () => {
  const [schools, setSchools] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchSchools = useCallback(async () => {
    try {
      const response = await AdminServices.getAllSchools({
        page: currentPage,
        search,
      });
      console.log("getAllSchools: ", response);
      setSchools(response.schools || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      console.error("Error fetching schools:", error);
    }
  }, [currentPage, search]);

  useEffect(() => {
    fetchSchools();
  }, [fetchSchools]);

  useEffect(() => {
    if (schools.length === 0) return; // Prevent initializing if no data

    if ($.fn.DataTable.isDataTable("#schoolsTable")) {
        $("#schoolsTable").DataTable().destroy(); // Destroy old instance before reinitializing
    }

    $("#schoolsTable").DataTable({
        responsive: true,
        autoWidth: false,
        paging: true, // ✅ Enable Pagination
        searching: true,
        ordering: true,
        pageLength: 10, // ✅ Set default entries per page
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]], // ✅ Add pagination options
    });
}, [schools]); // ✅ Re-run only when `schools` updates


  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper">
        {/* Header */}
        <AdminHeader activeMenu={"Dashboard"} />
        {/* /Header */}
        
        {/* Breadcrumb */}
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <h2 className="breadcrumb-title">Administrator</h2>
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/home">Home</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Schools List
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}

        {/* Page Content */}
        <div className="page-content">
          <div className="container">
            <div className="row">
              {/* Sidebar */}
              <AdminSidebar />
              {/* /Sidebar */}

              {/* School Dashboard */}
              <div className="col-xl-9 col-lg-9">
                <div className="dashboard-title">
                  <h4>Schools List</h4>
                </div>

                {/* Table with DataTables */}
                <div className="row">
                  <div className="table-responsive custom-table">
                    <table id="schoolsTable" className="table table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th></th>
                          <th>School Name</th>
                          <th>Email</th>
                          <th>Date</th>
                          <th>Payment</th>
                          <th>Payment Date</th>
                          <th>IP</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {schools.filter((school) => !school.isadmin).map((school, index) => (
                          <tr key={school._id}>
                            <td>{index + 1}</td>
                            <td>
                              {school.name}
                            </td>
                            <td>
                              {school.email}
                            </td>
                            <td>
                              {new Date(school.createdAt).toLocaleString()}
                            </td>
                            <td>
                              {school.payment?.amount
                                ? `$${school.payment.amount.toFixed(2)}`
                                : "N/A"}
                            </td>
                            <td>
                              {school.payment?.startDate
                                ? new Date(school.payment.startDate).toLocaleString()
                                : "N/A"}
                            </td>
                            <td>{school.ip ?? "N/A"}</td>
                            <td>
                              <Link to={`/admin/school-teacher-list/${school._id}`}>
                               View Teachers
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

             

              </div>
              {/* /School Dashboard */}
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default SchoolLists;
